import { currentUserQuery } from '@/api/user/userQueries';
import type { Role } from '@/domain/Role';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to check if the current user has any of the specified roles.
 * @param userRole - Optional user role. If not provided, will fetch from currentUserQuery.
 * @returns A function that checks if the user has any of the provided roles.
 */
export function useHasRole(userRole?: Role) {
  const { data: user } = useQuery(currentUserQuery);
  const role = userRole ?? user?.data.role;

  const hasRole = (...roles: Array<Role>): boolean => {
    if (!role) return false;
    return roles.includes(role);
  };

  return { hasRole, role };
}
